<template>
    <div>
        <el-date-picker
                    @change="query"
                    size="mini"
                    style="width:150px;z-index:999999;position:absolute;left:30px;top:105px"
                    v-model="selDate"
                    type="date"
                    placeholder="选择日期">
                    </el-date-picker>
          <el-table
          v-loading="isLoading"
            :data="tableData"
            show-summary
            :height="bodyHeight"
            style="width: 100%">
            <el-table-column
            prop="Name">
            </el-table-column>
            <el-table-column
            prop="Phone"
            label="手机号">
            </el-table-column>
            <el-table-column
            prop="ProcessNum"
            sortable
            label="进行中（单数）">
                <template slot-scope="scope">
                      <el-tag  size="small" type=""  >  {{ scope.row.ProcessNum }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="WaitNum"
            sortable
            label="待审核（单数）">
                <template slot-scope="scope">
                    <el-tag  size="small" type="Warning"  >  {{ scope.row.WaitNum }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="OkNum"
            sortable
            label="完成（单数）">
                <template slot-scope="scope">
                      <el-tag  size="small" type="success" >  {{ scope.row.OkNum }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="ErrorNum"
            sortable
            label="错误（单数）">
                <template slot-scope="scope">
                      <el-tag  size="small" type="danger" >  {{ scope.row.ErrorNum }} </el-tag>
                </template>
            </el-table-column>

            <el-table-column
            prop="LastTime"
            label="最后操作时间">
            </el-table-column>
            <el-table-column
            label="在线状态">
                <template slot-scope="scope">
                    <el-switch
                    :disabled="scope.row.Id==1"
                    @change="changeIsOnLine(scope.row)"
                    v-model="scope.row.IsOnLine"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column
            label="操作">
                <template slot-scope="scope">
                      <el-button size="mini" @click="redistribute(scope.row)">重新分配</el-button>

                </template>
            </el-table-column>
        </el-table>
        <el-dialog
  title="重新分配"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  将 <b style="color:#F56C6C">{{setRow.Name}}</b> 进行中的任务重新分配给
    <el-select size="small" style="margin-left:10px;width:100px"  filterable   v-model="aimsOutsiderId" clearable placeholder="审核人">
        <el-option v-for="v in outsiderList" :key="v.Id" :label="v.Name" :value="v.Id"> </el-option>
    </el-select>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="redistributeSumbit">确 定</el-button>
  </span>
</el-dialog>
    </div>
</template>

<script>
import { orderRedistribute,outsiderGetSel,orderGetKanBan,swipeBillSetIsOnLine} from '@/request.js'
import { formatDate } from '@/commonUtil.js'

export default {

    data(){
        return {
            bodyHeight:0,
            isLoading:false,
            tableData:[],
            selDate:"",
            timer:{},
            outsiderList:[],
            setRow:{},
            dialogVisible:false,
            aimsOutsiderId:"",
        }
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.selDate=new Date();
    },
    mounted(){
       this.query();
       outsiderGetSel({type:2},(res)=>{
           this.outsiderList=res.Result;
       })
       this.timer= setInterval(() => {
           this.query();
       }, 5000);
    },
    methods: {
        redistributeSumbit(){
            if(this.aimsOutsiderId==""){
                this.$message({
                    message: '请选择重新分配目标人员',
                    type: 'warning'
                });
                return;
            }
            orderRedistribute({outsiderId:this.setRow.Id,aimsOutsiderId:this.aimsOutsiderId},(res)=>{
                         if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.query();
                            this.dialogVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
            })
        },
        redistribute(scope){
            this.setRow=scope;
            this.dialogVisible=true;
        },
        changeIsOnLine(scope){
            swipeBillSetIsOnLine({isOnLine:scope.IsOnLine,outsiderId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
            })
        },
        query(){
            this.isLoading=true;
            var date= formatDate(new Date(this.selDate),"yyyy-MM-dd")
            orderGetKanBan({date:date},(res)=>{
                this.tableData=res.Result;
                this.isLoading=false;
            })
        },
    }
}
</script>